// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Y-v0i","drag-handle":"styles_drag-handle__WjDyq","dragHandle":"styles_drag-handle__WjDyq","dragging":"styles_dragging__J8G3b"};